import { render, staticRenderFns } from "./PatrolAdd.vue?vue&type=template&id=2b0db255&scoped=true"
import script from "./PatrolAdd.vue?vue&type=script&lang=js"
export * from "./PatrolAdd.vue?vue&type=script&lang=js"
import style0 from "./PatrolAdd.vue?vue&type=style&index=0&id=2b0db255&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0db255",
  null
  
)

export default component.exports